import React from 'react';
import classnames from 'classnames';

import "./news-item.scss";
import ValueUtils from '../../../ts/utils/ValueUtils';
import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import { AmazonTag } from '../../../ts/components/common/amazonTag/AmazonTag';
import { INewsItem } from '../../models/INewsItem';
import ProductCover from '../../../ts/components/common/productCover/ProductCover';
import { ImageDisplayType } from '../../../ts/components/common/PlaceholderImage';

export interface IProps {
    store: ManningOnlineStore;
    newsItem: INewsItem;
}
export interface IState {
    hasShowMoreLink: boolean;
    showWholeContent: boolean;
}

export class NewsItem extends React.Component <IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.onListAction = this.onListAction.bind(this);
        this.onDescriptionRef = this.onDescriptionRef.bind(this);
        this.onShowAll = this.onShowAll.bind(this);
        this.onProductLinkFollow = this.onProductLinkFollow.bind(this);

        this.state = {
            hasShowMoreLink: false,
            showWholeContent: false
        };
    }

    public render(){
        const newsItem = this.props.newsItem;
        newsItem.title = newsItem.title.replace("- MEAP published", "— MEAP published").replace("- Mobile release", "— Mobile release");
        const store = this.props.store;
        return <div className={classnames("news-item-root", this.getAdditionalRootClasses())}>
                    {newsItem.product && 
                    <div className="news-item-root-cover-container">
                        <ProductCover fullImage={newsItem.product.coverPath}
                                      placeholderImage = {this.props.store.coverPlaceholder}
                                      imageDisplayType = {ImageDisplayType.Image}
                                      className = "book-cover"
                                      height={130}
                                      width={105}
                                      placeholderOnlyOnFail={false}
                                      data={newsItem.product ? `${newsItem.product.manningId}` : ""}
                                      onDragStart={this.props.store.catalogState.coversAreDraggable ? this.props.store.onProductCoverDragStart : null}
                                      onClick={this.onProductLinkFollow}/>
                    </div> }
                    <div className="news-item-root-info-container">
                        <div className="news-item-header">
                            <span className={classnames("news-item-icon-container", {"meap-update": newsItem.type == "meapUpdate"})}>
                                { this.renderIcon()}
                            </span>
                            <span className="news-item-heading-title">
                                { this.renderTypeLabel(newsItem.link)}
                            </span>
                            { newsItem.amazonReleaseNumber && <AmazonTag number={newsItem.amazonReleaseNumber}/>}
                        </div>
                        
                        <div className="news-item-title-container">
                            <a href={newsItem.link} className="news-item-title" dangerouslySetInnerHTML={{__html: newsItem.title}} title={newsItem.title} onClick={this.onProductLinkFollow} target='_blank'></a>
                        </div>
                        <a href={newsItem.link} className={classnames("news-item-description", {"dont-clip-content": this.state.showWholeContent})} dangerouslySetInnerHTML={{__html: newsItem.description}} ref={this.onDescriptionRef}></a>
                        <div className="news-item-footer">
                            <div className="_footer-left">
                                { newsItem.date && <span className="news-item-footer-item">{ValueUtils.getDateAsString(new Date(newsItem.date))}</span>}
                                { newsItem.readingLengthInMinutes && <span className="news-item-footer-item">{newsItem.readingLengthInMinutes}min{newsItem.readingLengthInMinutes > 1 ? "s" : ""} read</span> }
                                { newsItem.forum && newsItem.forum.numberOfComments && <a href={newsItem.link} className="news-item-footer-item">{newsItem.forum.numberOfComments} comment{newsItem.forum.numberOfComments > 1 ? "s" : ""}</a> }
                                { newsItem.product && !newsItem.isDummy && <button onClick={this.onListAction}>
                                    { !store.isInAtLeastOneReadingList(newsItem)
                                    ? <><i className="fa fa-plus"/> add to list</>
                                    : <><i className="fa fa-check"/> edit list</>}
                                </button> }
                            </div>
                            <div className="_footer-right">
                                { this.state.hasShowMoreLink && !this.state.showWholeContent && <button onClick={this.onShowAll}>show all</button>}
                            </div>
                        </div>
                    </div>
               </div>
    }

    private onProductLinkFollow(e){
        if(e.target.nodeName != "A"){
            window.open(this.props.newsItem.link, "_blank")
        }

        this.props.store.logAction(`newsItemClick--${this.props.newsItem.link}`);

        return false;
    }

    private onShowAll(){
        this.setState({
            hasShowMoreLink: true,
            showWholeContent: true
        });
    }

    private onDescriptionRef(element){
        if(element != null){
            if(element.scrollHeight > element.clientHeight){
                if(!this.state.hasShowMoreLink){
                    this.setState({
                        hasShowMoreLink: true
                    });
                }
            }
        }
    }

    private getAdditionalRootClasses(){
        const newsItem = this.props.newsItem;
        return {   
            "trending-title": newsItem.type == "trendingTitle",
            "meap-update": newsItem.type == "meapUpdate",
            "forum-update": newsItem.type == "forumUpdate",
            "product-release": newsItem.type == "productRelease",
        }
    }

    private renderIcon(){
        const newsItem = this.props.newsItem;
        switch(newsItem.type){
            case 'meapUpdate':
                return <img src="https://lx-common-resources.s3-us-west-2.amazonaws.com/assets/meap-m.png" width={15} height={15}/>;
            case 'productRelease':
                return <img src="https://lx-common-resources.s3-us-west-2.amazonaws.com/assets/product-release-icon.svg" width={24} height={24}/>
            case 'trendingTitle':
                return <img src="https://lx-common-resources.s3-us-west-2.amazonaws.com/assets/trending-icon.svg" width={24} height={24}/>
            case 'forumUpdate':
                return newsItem.forum != null && newsItem.forum.avatarUrl 
                    ? <img src={newsItem.forum.avatarUrl} width={24} height={24}/>
                    : <i className="fa fa-user"/>
        }
    }

    private renderTypeLabel(url: string = null){
        const newsItem = this.props.newsItem;
        switch(newsItem.type){
            case 'meapUpdate':
                return "published";
            case 'productRelease':
                if(url != null && url.indexOf("livebook") >= 0){
                    return "new book";
                }
                else if(url != null && url.indexOf("livevideo") >= 0){
                    return "new liveVideo";
                }
                else if(url != null && url.indexOf("liveproject") >= 0){
                    return "new liveProject";
                }
                return "product release";
            case 'trendingTitle':
                return "trending title";
            case 'forumUpdate':
                return newsItem.forum != null ? newsItem.forum.title : "forum update"
        }
    }

    private onListAction(){
        this.props.store.requestReadingListSpecificationForNewsProduct(this.props.newsItem.product);
    }
}